import { Component, OnInit, Input } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';
import { fuseAnimations } from '../../../../../../../../core/animations';

//Service file
import { EcommerceOrderService } from '../../../../order/order.service';
import { SolutionFormService } from '../../../solutionForm.service';
/**Local file */
import { orders, spekwo, spekwoType, checkoutFields } from '../../../../../utils/index';
import { CommonOrdersService } from '../../../../orders/commonOrders.service';

@Component({
    selector: 'orderDetails',
    templateUrl: './orderDetails.component.html',
    styleUrls: ['./orderDetails.component.scss'],
    animations: fuseAnimations
})

export class OrderDetailsSidenavComponent {

    @Input() totalJobValue;

    selected: any;
    currentOrderDetails: any;
    currentOrderId: any;

    onOrderChanged: Subscription;
    acceptedDate: Date | string;
    acceptedBy: string;

    ordersValues = orders;
    spekwoType = spekwoType;
    spekwoValues = spekwo;
    checkoutFields = checkoutFields;
    allStatus: OrderStatus[];

    acceptStatus: boolean = false;
    detailSpinner: boolean = false;
    status: string;
    statusId;

    orderRating: number = 0;

    constructor(
        private route: ActivatedRoute,
        /**Service file */
        private orderService: EcommerceOrderService,
        private formService: SolutionFormService,
        public commonOrdersService: CommonOrdersService,
    ) {

    }

    ngOnInit() {
        this.commonOrdersService.listOfStatus.subscribe((statusRes) => {
            this.allStatus = statusRes.length > 0 ? statusRes : [];
        });
        this.detailSpinner = true;

        this.currentOrderId = this.route &&
            this.route.snapshot &&
            this.route.snapshot.params &&
            this.route.snapshot.params.id;

        // 1.Subscribe to update order on changes -get current order details
        this.onOrderChanged = this.orderService.onOrderChanged
            .subscribe(order => {

                this.currentOrderDetails = order;
                this.detailSpinner = false;

            }, () => {

                this.detailSpinner = false;

            });

        //Check this report submitted by clieent
        this.formService.checkOrderStatus(this.currentOrderId)
            .then((data: any) => {

                this.detailSpinner = true;

                if (data.length > 0) {

                    this.acceptedDate = data[0].node &&
                        data[0].node.acceptedDate !== ' ' ? data[0].node.acceptedDate : '-';

                    // Pro details hided if status any of the following
                    this.statusId = data[0].node &&
                        data[0].node.statusId ? data[0].node.statusId : null;
                    this
                    this.acceptStatus = this.statusId ? true : false;

                    let filterStatus = this.allStatus.filter((status) => {
                        return status.statusId === this.statusId;
                    })
                    // this.status = this.allStatus[this.statusId - 1].displayStatus; //Get display status of order
                    this.status = filterStatus.length > 0 && filterStatus[0].displayStatus ? filterStatus[0].displayStatus : "No status"; //Get display status of order



                    if (this.acceptStatus) {

                        // # Get  IC name who is accepted this order
                        this.formService.GetUserNameById(data[0].node.acceptedBy)
                            .then((data: any) => {

                                if (data.length > 0) {
                                    this.acceptedBy = data[0].node.firstName + ' ' + data[0].node.lastName;
                                }
                                this.detailSpinner = false;
                            })
                            .catch(() => {
                                this.detailSpinner = false;
                            })

                        //Get rating of current order if client provided
                        this.formService.getRating(this.currentOrderId)
                            .then((responseData: any) => {

                                if (responseData.length > 0) {
                                    this.orderRating = responseData[0].node.rating;
                                }

                            })
                            .catch(() => {
                                this.detailSpinner = false;
                            })



                    } else {
                        this.detailSpinner = false;
                    }

                } else {
                    this.detailSpinner = false;
                }

            })
            .catch(() => {
                this.detailSpinner = false;
            })


    }


    ngOnDestroy() {
        this.onOrderChanged.unsubscribe();
    }

    //fetching types of product
    fetchingProduct(name) {
        return this.spekwoValues[name];
    }
    //Get subjectProperty 
    getSubjectPropertyAddress(meta_data) {
        var found = false, matchkey;
        meta_data.forEach((data, key) => {
            if (data.key === this.checkoutFields.buyerProperty) {
                found = true;
                matchkey = key
            }
        });
        if (found) {
            return meta_data[matchkey].value;
        }
    }

    //Check empty object or not
    checkObject(obj) {
        return _.isEmpty(obj);
    }

}

export interface OrderStatus {
    statusId: number;
    statusName: string;
    displayStatus: string;
}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/solutionForm/spekwo-type/after-client-accept-list/order-details/orderDetails.component.ts